import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { HomologacionPlanCargoService } from '../../_services/homologacion-plan-cargo.service';
import { BusquedaFiltros } from '../../_models/busqueda-filtros';
import { Table } from 'primeng/table';
import { HomologacionPlanCargo } from '../../_models/homologacion-plan-cargo';
import { RutasFuncionalidades } from '../../_enums/enum';
import { FuncionalidadesService } from '../../_services/funcionalidades.service';
import { forkJoin } from 'rxjs';
import { UsuarioComisionFreelance } from '../../_models/usuario-comision-freelance';

@Component({
  selector: 'app-homologacion-planes-cargos',
  templateUrl: './homologacion-planes-cargos-listado.component.html',
  styleUrls: ['./homologacion-planes-cargos-listado.component.css']
})
export class HomologacionPlanesCargosListadoComponent implements OnInit {

  cargando = true;
  funcionalidad: Funcionalidad = new Funcionalidad();
  homologacionPlanCargo: HomologacionPlanCargo[] = [];
  busqueda: string = '';
  columnas: any[];
  filtroBusqueda = [
    'planCargoProducto',
    'codigoPlanCargoGarantia',
    'codigoPlanCargoProducto',
    'planCargoGarantia',
    'codigoShivam',
    'indicadorHabilitado'
  ];
  @ViewChild("dt", { static: true }) tabla: Table;
  carInformacion = true;
  pagina: string;
  regPorPagina = 10;
  submitted = false;
  indicador = false;
  agregar = false;
  editar = false;


  constructor(private authService: AutenticacionService,
    private navService: NavService,
    private router: Router,
    private fb: FormBuilder,
    private funcionalidadService: FuncionalidadesService,
    private homologacionPlanCargoService: HomologacionPlanCargoService
  ) { }

  ngOnInit() {
    const mn = this.authService.obtenerFuncionalidades().find((x) => x.ruta === RutasFuncionalidades.HOMOLOGACIONPLANCARGO);
    if (mn) {
      this.funcionalidad = mn;
    }
    this.validarRol();
    this.cargaInicial();
  }

  validarRol() {
    if (this.funcionalidad && this.funcionalidad.editar) {
      this.editar = true;
    } else {
      this.navService.setMesage(0, {
        severity: 'info',
        summary: this.navService.buscarMensaje('LBL_INFORMACION'),
        detail: this.navService.buscarMensaje('HOMOLOGACIONPLANESCARGOS.MSG_NOEDITAR'),
      });
    }

    if (this.funcionalidad && this.funcionalidad.agregar) {
      this.agregar = true;
    } else {
      this.navService.setMesage(0, {
        severity: 'info',
        summary: this.navService.buscarMensaje('LBL_INFORMACION'),
        detail: this.navService.buscarMensaje('HOMOLOGACIONPLANESCARGOS.MSG_SINPERMISOS'),
      });
    }
  }

  agregarPlanCargo() {
    this.router.navigate(['apl/homologacion-plan-cargo/agregar']);
  }

  editarPlanCargo(homologacionPlanCargo: HomologacionPlanCargo) {
    this.router.navigate(['apl/homologacion-plan-cargo/actualizar/' + homologacionPlanCargo.idHomologacionPlanCargo]);
  }

  cargarColumnas() {
    this.columnas = [
      { field: 'planCargosProducto', header: this.navService.buscarMensaje('HOMOLOGACIONPLANESCARGOS.LBL_PLANCARGOSPRODUCTO'), sort: true },
      { field: 'planComodinGarantia', header: this.navService.buscarMensaje('HOMOLOGACIONPLANESCARGOS.LBL_COMODINFONDOSGARANTIAS'), sort: true },
      { field: 'codigoShivam', header: this.navService.buscarMensaje('HOMOLOGACIONPLANESCARGOS.LBL_CODIGO'), sort: true },
      { field: 'indicadorHabilitado', header: this.navService.buscarMensaje('HOMOLOGACIONPLANESCARGOS.LBL_INDICADORHABILITADO'), sort: true },
      { field: 'acciones', header: this.navService.buscarMensaje('LBL_ACCIONES'), sort: false },
    ];
    this.carInformacion = false;
    this.cargando = false;

    this.busqueda = this.navService.getSearch(
      "homologacion-plan-cargo.component"
    );
  }

  cargaInicial() {
    this.cargarColumnas();
    forkJoin(this.homologacionPlanCargoService.listado()).subscribe(([homologacionPlanCargo]) => {
      this.homologacionPlanCargo = homologacionPlanCargo;
    });
  }

  habilitarInhabilitar(row: HomologacionPlanCargo) {
    this.indicador = true;
    if (row.indicadorHabilitado) {
      this.homologacionPlanCargoService.actualizar(row).subscribe((rta) => {
        this.navService.setMesage(2);
        this.indicador = false;
        this.submitted = false;
      });
    } else {
      this.homologacionPlanCargoService.actualizar(row).subscribe((rta) => {
        this.navService.setMesage(2);
        this.indicador = false;
        this.submitted = false;
      });
    }
  }

  setBusqueda() {
    this.navService.setSearch(
      "homologacion-plan-cargo.component",
      this.busqueda
    );
  }
}
